<bl-select-modal-base
  [title]="'MODALS.SELECT_DOCUMENT_CATEGORY.TITLE' | translate"
  (closeClick)="dismiss()"
  [showSearchBar]="false"
  [showHeaderBorder]="true"
  class="ion-page"
>
  <h2 class="color--medium text--sm text--medium pb-2">
    {{ "MODALS.SELECT_DOCUMENT_CATEGORY.SUBTITLE" | translate }}
  </h2>

  <div
    *ngIf="here"
    class="level"
  >
    <ion-button
      fill="clear"
      size="small"
      (click)="up()"
      [attr.aria-label]="'COMMON.LABELS.BACK' | translate"
      [title]="'COMMON.LABELS.BACK' | translate"
      data-cy="folder-up"
    >
      <svg-icon
        slot="icon-only"
        key="arrow-left"
        class="color--dark"
        aria-hidden="true"
      ></svg-icon>
    </ion-button>
    <h3 class="text--base text--medium">{{ here.name }}</h3>
  </div>

  <ion-list lines="none">
    <ion-item
      *ngIf="!here"
      detail
      (click)="dismiss()"
    >
      <ion-label class="font--base">
        {{ "COMMON.LABELS.NONE" | translate }}
      </ion-label>
    </ion-item>
    <ion-item
      *ngFor="let folder of folders"
      button
      detail="false"
      (click)="pick(folder)"
      data-cy="pick-folder"
    >
      <ion-label class="font--base">{{ folder.name }}</ion-label>
      <ion-button
        *ngIf="folder.folders_count"
        slot="end"
        fill="clear"
        size="small"
        (click)="enter($event, folder)"
        [attr.aria-label]="
          'MODALS.SELECT_DOCUMENT_CATEGORY.OPEN'
            | translate: { name: folder.name }
        "
        data-cy="open-folder"
      >
        <svg-icon
          slot="icon-only"
          key="caret-down"
          class="open-caret"
          aria-hidden="true"
        ></svg-icon>
      </ion-button>
    </ion-item>
  </ion-list>
</bl-select-modal-base>
